
export const initProps = (props, _context, thisArg) => {
    if (!props) {
        return
    }
    //处理属性响应
    //表达式 ${user.create.name},
    matchProps(props, /\$\{([^}]+)\}/g, (o, prop, value, key) => {
        //判断变量是否在字符中 如 名称${name} evalProps处理变量 ,rept处理字符串模板
        console.log(o,prop,value)
        o[prop] = /^\$\{([^}]+)\}$/.test(value) ?
            evalProps(thisArg, _context, key) :
            rept(value, /\$\{([^}]+)\}/g, _context, thisArg)
    })
}
const rept = function (str, patt, data, thisArg) {
    // eslint-disable-next-line no-unused-vars
    return str.replace(patt, function (_matched, key, _index, _str) {
        return evalProps(thisArg, data, key)
    })
}
const is = (val, type) => {
    return toString.call(val) === `[object ${type}]`
}

const ignoreProp = ['_tag', '_id','_pid']

const matchProps = (o, patt, callback) => {
    Object.keys(o).forEach((prop) => {
        if (ignoreProp.indexOf(prop) != -1) {
            return
        }
        const value = o[prop]
        //无效值
        if (!value) {
            return
        }
        //数组处理
        if (Array.isArray(value)) {
            Array.from(value || []).forEach((i) => {
                matchProps(i, patt, callback)
            })
            return
        }

        //如果是对象,递归处理
        if (is(value, 'Object')) {
            matchProps(value, patt, callback)
            return
        }

        if (!is(value, 'String') || !patt.test(value.toString())) {
            return
        }
        //处理字符串
        // eslint-disable-next-line no-unused-vars
        value.toString().replace(patt, function (_matched, key, _index, _str) {
            return callback ? callback(o, prop, value, key) : ''
        })
    })
}
export const getValue = (o, prop, val) => {
    const props = prop.split('.')
    let obj = o
    for (let i = 0; i < props.length; i++) {
        let key = props[i]
        obj = obj[key]
        if (obj === null || obj === undefined) {
            return val
        }
    }
    return obj
}
export const setValue = (o, prop, val) => {
    const props = prop.split('.')
    let obj = o
    for (let i = 0; i < props.length; i++) {
        let key = props[i]
        //取属性没有值,创建属性
        if (!obj[key] && i < props.length - 1) {
            obj[key] = {}
            obj = obj[key]
            //取属性有值
        } else if (i < props.length - 1) {
            obj = obj[key]
            //最后属性
        } else if (i == props.length - 1) {
            obj[key] = val
        }
    }
}
export const setDefValue = (o, prop, val) => {
    const props = prop.split('.')
    let obj = o
    for (let i = 0; i < props.length; i++) {
        let key = props[i]
        //取属性没有值,创建属性
        if (!obj[key] && i < props.length - 1) {
            obj[key] = {}
            obj = obj[key]
            //取属性有值
        } else if (i < props.length - 1) {
            obj = obj[key]
            //最后属性
        } else if (i == props.length - 1) {
            obj[key] = obj[key] || val
        }
    }
}
//表达式取值  this.a.b.c 转换为 转换为 ()=>this.a.b.c
const evalProps = (thisArg, context, script) => {
    //取值
    const names = Object.keys(context)
    const vals = names.map((i) => context[i])
    console.log(context, script,context['selection'],vals)
    var f = new Function(...names, 'return ' + script)
    // console.log(f,vals)
    try {
        return f.apply(thisArg, vals) //可通this取当前属性数据
    } catch (e) {
        console.log(e)
        return ''
    }
}

